<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">
        {{ $t('creditTransfer.pageTitle') }}
      </h1>
      <ts-breadcrumb :items="[
        { text: $t('toHomePage'), href: '/' },
        {
          text: $t('creditTransfer.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-12">
            <div class="form-group">
              <form class="form-horizontal">
                <fieldset>
                  <legend>{{ $t('creditTransfer.actionForm') }}</legend>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="col-md-3 col-form-label">
                                {{
                                  $t(
                                    'school.academic.operation.profile_mgt.studentProfile.nameKh'
                                  )
                                }}
                              </label>
                              <div class="col-md-8">
                                <fieldset>
                                  <div class="row form-group">
                                    <div class="col-md-6">
                                      <input type="text" v-model="model.first_name_kh" class="form-control" :class="{
                                        'is-invalid': errors.has('first_name_kh')
                                      }" :placeholder="$t(
                                        'school.academic.operation.profile_mgt.studentProfile.firstName'
                                      )
                                        " />
                                      <div class="invalid-feedback" v-if="errors.has('first_name_kh')">
                                        {{ errors.first('first_name_kh') }}
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <input type="text" v-model="model.last_name_kh" class="form-control" :class="{
                                        'is-invalid': errors.has('last_name_kh')
                                      }" :placeholder="$t(
                                        'school.academic.operation.profile_mgt.studentProfile.lastName'
                                      )
                                        " />
                                      <div class="invalid-feedback" v-if="errors.has('last_name_kh')">
                                        {{ errors.first('last_name_kh') }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-12">
                                      <input type="text" class="form-control" readonly :value="fullNameKh" :placeholder="$t(
                                        'school.academic.operation.profile_mgt.studentProfile.fullNameKh'
                                      )
                                        " />
                                    </div>
                                  </div>
                                </fieldset>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="col-md-3 col-form-label required">
                                {{
                                  $t(
                                    'school.academic.operation.profile_mgt.studentProfile.gender'
                                  )
                                }}
                              </label>
                              <div class="col-md-8">
                                <div class="radio radio-css radio-inline">
                                  <input type="radio" id="male" v-model="model.gender" value="Male"
                                    @input="$v.model.gender.$touch()" :class="{
                                      'is-invalid':
                                        errors.has('gender') || $v.model.gender.$error
                                    }" />
                                  <label for="male">Male</label>
                                </div>
                                <div class="radio radio-css radio-inline">
                                  <input type="radio" id="female" v-model="model.gender" value="Female"
                                    @input="$v.model.gender.$touch()" :class="{
                                      'is-invalid':
                                        errors.has('gender') || $v.model.gender.$error
                                    }" />
                                  <label for="female">Female</label>
                                </div>
                                <br />
                                <span class="validate" v-if="genderErrors.length > 0">{{
                                  genderErrors[0]
                                }}</span>
                                <div class="invalid-feedback" v-if="errors.has('gender')">
                                  {{ errors.first('gender') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row text-right">
                              <label class="col-label form-label required col-md-3">{{
                                $t('creditTransfer.fromSchool')
                              }}</label>
                              <div class="col-md-8">
                                <input type="text" v-model="model.school_university" :class="{
                                  'is-invalid': errors.has('school_university')
                                }" class="form-control" />

                              </div>
                              <div class="invalid-feedback" v-if="errors.has('school_university')">
                                {{ errors.first('school_university') }}
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row text-right">
                              <label class="col-label form-label col-md-3 required">{{
                                $t('creditTransfer.major')
                              }}</label>
                              <div class="col-md-8">
                                <input type="text" class="form-control" :class="{
                                  'is-invalid': errors.has('department')
                                }" v-model="model.department">
                              </div>
                              <div class="invalid-feedback" v-if="errors.has('department')">
                                {{ errors.first('department') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row text-right">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="form-label col-label col-md-3 required">{{
                                $t('creditTransfer.level')
                              }}</label>
                              <div class="col-md-8">
                                <select style="width: 100%;" class="form-control" v-model="model.degree"
                                  :class="{ 'is-invalid': errors.has('academic_semester') }">
                                  <option :value="null" disabled selected style="display: none">
                                    {{ $t('select') }}
                                  </option>
                                  <option v-for="(degree, index) in degrees" :value="degree"
                                    :key="index">
                                    {{ degree }}
                                  </option>
                                </select>
                              </div>
                              <div class="invalid-feedback" v-if="errors.has('degree')">
                                {{ errors.first('degree') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row text-right">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="col-label form-label col-md-3 required">{{
                                $t('creditTransfer.numberOfYear')
                              }}</label>
                              <div class="col-md-8">
                                <input type="text" :class="{
                                  'is-invalid': errors.has('number_of_year_studied')
                                }" class="form-control" v-model="model.number_of_year_studied">
                              </div>
                              <div class="invalid-feedback" v-if="errors.has('number_of_year_studied')">
                                {{ errors.first('number_of_year_studied') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row text-right">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="form-label col-label col-md-3 required">{{
                                $t('creditTransfer.numberOfSemeter')
                              }}</label>
                              <div class="col-md-8">
                                <input type="text" :class="{
                                  'is-invalid': errors.has('number_of_semester_studied')
                                }" class="form-control" v-model="model.number_of_semester_studied">

                              </div>
                              <div class="invalid-feedback" v-if="errors.has('number_of_semester_studied')">
                                {{ errors.first('number_of_semester_studied') }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>



                    </div>
                    <div class="col-md-6">
                      <div class="row">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="col-md-3 col-form-label required mt-2">
                                {{
                                  $t(
                                    'school.academic.operation.profile_mgt.studentProfile.nameEn'
                                  )
                                }}
                              </label>
                              <div class="col-md-8">
                                <fieldset>
                                  <div class="row form-group">
                                    <div class="col-md-6">
                                      <input type="text" v-model="model.first_name_en" class="form-control" :class="{
                                        'is-invalid':
                                          errors.has('first_name_en') ||
                                          $v.model.first_name_en.$error
                                      }" :placeholder="$t(
                                        'school.academic.operation.profile_mgt.studentProfile.firstName'
                                      )
                                        " />
                                      <span class="invalid-feedback" v-if="lastNameEnErrors.length > 0">{{
                                        lastNameEnErrors[0]
                                      }}</span>
                                      <div class="invalid-feedback" v-if="errors.has('first_name_en')">
                                        {{ errors.first('first_name_en') }}
                                      </div>
                                    </div>
                                    <div class="col-md-6">
                                      <input type="text" v-model="model.last_name_en" class="form-control" :class="{
                                        'is-invalid':
                                          errors.has('last_name_en') ||
                                          $v.model.last_name_en.$error
                                      }" :placeholder="$t(
                                        'school.academic.operation.profile_mgt.studentProfile.lastName'
                                      )
                                        " />
                                      <span class="invalid-feedback" v-if="firstNameEnErrors.length > 0">{{
                                        firstNameEnErrors[0]
                                      }}</span>
                                      <div class="invalid-feedback" v-if="errors.has('last_name_en')">
                                        {{ errors.first('last_name_en') }}
                                      </div>
                                    </div>
                                  </div>
                                  <div class="row">
                                    <div class="col-md-12">
                                      <input type="text" class="form-control" readonly :value="fullNameEn" :placeholder="$t(
                                        'school.academic.operation.profile_mgt.studentProfile.fullNameEn'
                                      )
                                        " />
                                    </div>
                                  </div>
                                </fieldset>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row text-right">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="form-label col-label col-md-3">{{
                                $t('creditTransfer.dateOfBirth')
                              }}</label>
                              <div class="col-md-8">
                                <ts-date-picker-input v-model="model.dob" />
                                <div v-if="errors.has('date_of_birth')" class="validate">
                                  {{ errors.first('date_of_birth') }}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row text-right">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="form-label col-label col-md-3">{{
                                $t('creditTransfer.equalAcYear')
                              }}</label>
                              <div class="col-md-8">
                                <input type="text" class="form-control" v-model="model.equi_academic_year">
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                      <div class="row text-right">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="form-label col-label col-md-3">{{
                                $t('creditTransfer.equalAcTerm')
                              }}</label>
                              <div class="col-md-8">
                                <input type="text" class="form-control" v-model="model.equi_academic_semester">

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row text-right">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="form-label col-label col-md-3">{{
                                $t('creditTransfer.equalmajor')
                              }}</label>
                              <div class="col-md-8">
                                <a-select style="width: 100%" v-model="model.equi_acps_id" :options="sub_programs"
                                  :class="{
                                    'is-invalid': errors.has('acps_id')
                                  }" :show-search="true" :filter-option="(input, option) =>
                                    option.componentOptions.children[0].text
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                    " @change="onSubChange"></a-select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row text-right">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="form-label col-label col-md-3">{{
                                $t('creditTransfer.equallevel')
                              }}</label>
                              <div class="col-md-8">
                                <a-select v-model="model.equi_level_id" :options="levels" :loading="filterSub"
                                  showSearch :filterOption="(input, option) =>
                                    option.componentOptions.children[0].text
                                      .toLowerCase()
                                      .indexOf(input.toLowerCase()) >= 0
                                    " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')"
                                  @change="levelChange">
                                </a-select>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row text-right">
                        <div class="col-md-12">
                          <div class="form-group">
                            <div class="row">
                              <label class="form-label col-label col-md-3">{{
                                $t('creditTransfer.equalPromotion')
                              }}</label>
                              <div class="col-md-8">
                                <input type="text" class="form-control" v-model="model.equi_promoiton" />

                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-md-12">
                      <panel :title="$t('creditTransfer.subjectDetail')">
                        <div class="overflow-auto">
                          <div id="container-table">
                            <table class="table ui-table table-hover" style="min-width:1520px">
                              <thead>
                                <tr>
                                  <th>{{ $t('creditTransfer.acYear') }}</th>
                                  <th>{{ $t('creditTransfer.semester') }}</th>
                                  <th>{{ $t('creditTransfer.subject') }}</th>
                                  <th>{{ $t('creditTransfer.credit') }}</th>
                                  <th>{{ $t('creditTransfer.grade') }}</th>
                                  <th>{{ $t('creditTransfer.equalAcYear') }}</th>
                                  <th>{{ $t('creditTransfer.equalAcTerm') }}</th>
                                  <th>{{ $t('creditTransfer.equalSubject') }}</th>
                                  <th>{{ $t('creditTransfer.equalCredit') }}</th>
                                  <th>{{ $t('creditTransfer.equalGrade') }}</th>
                                  <th style="width: 2%" class="text-center">
                                    <a href="#" class="text-primary">
                                      <i class="fas fa-spinner spin" v-if="ready_fetch"></i>
                                      <i class="fa fa-plus" v-else @click.prevent="addNewRow"></i>
                                    </a>
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in model.transfer_id_list" :key="index">
                                  <td>
                                    <select style="width: 200px;" class="form-control" v-model="item.academic_year"
                                      :class="{ 'is-invalid': errors.has('academic_year') }" ref="academic_year">
                                      <option :value="null" disabled selected style="display: none">
                                        {{ $t('select') }}
                                      </option>
                                      <option v-for="(year, index) in academic_years" :value="year" :key="index">
                                        {{ year }}
                                      </option>
                                    </select>
                                  </td>
                                  <td>
                                    <select style="width: 200px;" class="form-control" v-model="item.academic_semester"
                                      :class="{ 'is-invalid': errors.has('academic_semester') }">
                                      <option :value="null" disabled selected style="display: none">
                                        {{ $t('select') }}
                                      </option>
                                      <option v-for="(term, index) in academic_terms" :value="term" :key="index">
                                        {{ term }}
                                      </option>
                                    </select>
                                  </td>
                                  <td>
                                    <input type="text" v-model="item.subject_name" class="form-control"
                                      style="width: 200px;" />
                                  </td>
                                  <td>
                                    <input type="text" v-model="item.subject_credit" class="form-control"
                                      style="width: 200px;" />
                                  </td>
                                  <td>
                                    <input type="text" v-model="item.subject_grade" class="form-control"
                                      style="width: 200px;" />
                                  </td>
                                  <td>
                                    <select style="width: 200px;" class="form-control" v-model="item.equi_academic_year"
                                      :class="{ 'is-invalid': errors.has('equi_academic_year') }" ref="academic_year">
                                      <option :value="null" disabled selected style="display: none">
                                        {{ $t('select') }}
                                      </option>
                                      <option v-for="(year, index) in academic_years" :value="year" :key="index">
                                        {{ year }}
                                      </option>
                                    </select>

                                  </td>
                                  <td>

                                    <select style="width:200px;" class="form-control"
                                      v-model="item.equi_academic_semester"
                                      :class="{ 'is-invalid': errors.has('equi_academic_semester') }">
                                      <option :value="null" disabled selected style="display: none">
                                        {{ $t('select') }}
                                      </option>
                                      <option v-for="(term, index) in academic_terms" :value="term" :key="index">
                                        {{ term }}
                                      </option>
                                    </select>
                                  </td>
                                  <td>

                                    <a-select style="width:200px" :options="subjects" v-model="item.equi_subject_id"
                                      showSearch :filterOption="(input, option) =>
                                        option.componentOptions.children[0].text
                                          .toLowerCase()
                                          .indexOf(input.toLowerCase()) >= 0
                                        " :maxTagCount="1" :maxTagTextLength="17" :placeholder="$t('all')"></a-select>
                                    <div class="validate" v-if="errors.has('equi_subject_id')">
                                      {{ errors.first('equi_subject_id') }}
                                    </div>
                                  </td>
                                  <td>
                                    <input type="text" v-model="item.equi_subject_credit" class="form-control"
                                      style="width: 200px;" />
                                  </td>
                                  <td>
                                    <input type="text" v-model="item.equi_subject_grade" class="form-control"
                                      style="width: 200px;" />
                                  </td>
                                  <td class="text-center">
                                    <a href="#" class="text-danger" @click.prevent="removeRow(item)">
                                      <i class="fa fa-trash"></i>
                                    </a>
                                  </td>
                                </tr>

                              </tbody>
                              
                            </table>
                            <div class="validate" v-if="errors.has('transfer_id_list')">
                    {{ errors.first('transfer_id_list') }}
                  </div>
                          </div>
                        </div>
                      </panel>
                    </div>
                  </div>
                </fieldset>
              </form>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-right mt-2">
            <ts-button @click="$router.push({ name: 'cradit-transfer' })" class="btn btn-default mr-2">{{ $t('cancel')
            }}</ts-button>
            <ts-button outline color="primary" :waiting="saving_new" @click.prevent="saveAddNew">{{ $t('save_add_new')
            }}</ts-button>
            <ts-button class="btn btn-primary ml-2" :waiting="waiting_save" @click.prevent="store">{{ $t('save')
            }}</ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import { Errors } from 'form-backend-validation'
import { required } from 'vuelidate/lib/validators'
import { mapActions, mapState } from 'vuex';

export default {
  name: 'credit-transfer',
  data() {
    return {
      loading: false,
      ready_fetch: false,
      level_loading: false,
      filterSub: false,
      saving_new: false,
      waiting_save: false,
      errors: new Errors(),
      levels: [],
      sub_programs: [],
      ac_year_list: [],
      ac_terms: [],
      subjects: [],
      model: {
        level_id: null,
        first_name_kh: null,
        last_name_kh: null,
        first_name_en: null,
        last_name_en: null,
        dob: null,
        school_university: null,
        degree: null,
        department: null,
        equi_academic_year: null,
        equi_acps_id: null,
        equi_academic_semester: null,
        equi_promoiton: null,
        equi_subject_id: null,
        equi_level_id: null,
        number_of_year_studied: null,
        number_of_semester_studied: null,
        transfer_id_list: []
      },
      newRow: {
        academic_year: null,
        academic_semester: null,
        equi_academic_semester: null,
        equi_academic_year: null,
        subject_name: null,
        subject_credit: null,
        subject_grade: null,
        equi_subject_id: null
      }
    }
  },
  validations: {
    model: {
      first_name_en: { required },
      last_name_en: { required },
      gender: { required }
    },
    form: ['model.first_name_en', 'model.last_name_en', 'gender']
  },
  computed: {
    ...mapState('crediTransfer', ['academic_years', 'academic_terms','degrees']),
    fullNameKh() {
      return (
        (this.model.first_name_kh ? this.model.first_name_kh : '') +
        (this.model.last_name_kh ? ' ' + this.model.last_name_kh : '')
      )
    },
    fullNameEn() {
      return (
        (this.model.first_name_en ? this.model.first_name_en : '') +
        (this.model.last_name_en ? ' ' + this.model.last_name_en : '')
      )
    },
    firstNameEnErrors() {
      const errors = []
      if (!this.$v.model.first_name_en.$error) return errors
      !this.$v.model.first_name_en.required && errors.push('Required')
      return errors
    },
    lastNameEnErrors() {
      const errors = []
      if (!this.$v.model.last_name_en.$error) return errors
      !this.$v.model.last_name_en.required && errors.push('Required')
      return errors
    },
    genderErrors() {
      const errors = []
      if (!this.$v.model.gender.$error) return errors
      !this.$v.model.gender.required && errors.push('Required')
      return errors
    }
  },
  created() {
    this.fetchData()
    this.getSubject()
  },
  methods: {
    ...mapActions('crediTransfer', ['getLevel', 'getSubProgram', 'getYear', 'getTerm', 'getSubject']),
    async fetchData() {
      await this.getSubProgram().then(response => {
        this.sub_programs = response.data.map(el => ({
          value: el.acps_id,
          label: el.acps_name_foreign
        }))
      })
      await this.getYear()
        .then(response => {
          this.ac_year_list = response.data.map(el => ({
            value: el.ac_year_id,
            label: el.ac_year
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
      await this.getSubject()
        .then(response => {
          this.subjects = response.map(el => ({
            value: el.subject_id,
            label: el.subject_name_foreign
          }));
        })
        .catch(error => {
          this.$toasted.error(error.message);
        })
        .finally(() => {
          this.loading = false;
        });
      await this.getTerm({
        filter: {
          level_id: level_id
        }
      })
        .then(response => {
          this.ac_terms = response.data.map(el => ({
            value: el.ac_term_id,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                  ? ' ( History ) '
                  : null)
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.filterLevel = false
        })

    },

    async onSubChange(acps_id) {
      this.model.level_id = []
      this.levels = []
      this.filterSub = true
      await this.getLevel({
        filter: {
          acps_id: acps_id
        }
      })
        .then(response => {
          this.levels = response.data.map(el => ({
            value: el.level_id,
            label: el.level_name_foreign
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.filterSub = false
        })
    },
    async levelChange(level_id) {
      this.filterLevel = true
      this.model.ac_term_id = null
      await this.getTerm({
        filter: {
          level_id: level_id
        }
      })
        .then(response => {
          this.ac_terms = response.data.map(el => ({
            value: el.ac_term_id,
            label:
              el.term_name +
              (el.ac_status_id == 1
                ? ' ( Current ) '
                : el.ac_status_id == 2
                  ? ' ( History ) '
                  : null)
          }))
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.filterLevel = false
        })
    },
    addNewRow() {
      this.model.transfer_id_list.push(_.clone(this.newRow))

    },
    removeRow(item) {
      this.model.transfer_id_list.splice(this.model.transfer_id_list.indexOf(item), 1)
    },
    async store() {
      this.waiting_save = true
      this.$store
        .dispatch('crediTransfer/store', this.model)
        .then(response => {
          this.waiting_save = false
          this.$toasted.success(response.message)
          this.$router.push({ name: 'cradit-transfer' })
        })
        .catch(error => {
          this.waiting_save = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    saveAddNew() {
      this.errors = new Errors()
      this.saving_new = true
      this.$store
        .dispatch('crediTransfer/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearForm()
          this.saving_new = false
        })
        .catch(error => {
          this.saving_new = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    clearForm() {
      this.model = {
        level_id: null,
        first_name_kh: null,
        last_name_kh: null,
        first_name_en: null,
        last_name_en: null,
        dob: null,
        school_university: null,
        degree: null,
        department: null,
        equi_academic_year: null,
        equi_acps_id: null,
        equi_academic_semester: null,
        equi_promoiton: null,
        equi_subject_id: null,
        equi_level_id: null,
        transfer_id_list: []
      }
    }
  }
}
</script>

<style lang="css" scoped>
.panel {
  margin-bottom: 0 !important;
}

#list-container {
  white-space: nowrap;
}

.table>thead>tr>th {
  position: sticky;
  position: -webkit-sticky;
  top: 0;
  z-index: 2;
  background: #f2f3f4;
}

.table>tbody>tr>td {
  padding-top: 5px !important;
  padding-bottom: 5px !important;
  border: none !important;
}
</style>
